import { useState, useRef, memo } from "react";
import { Form, Row, Col, Button } from "react-bootstrap";
import TroisBoutonsAccueil from './TroisBoutonsAccueil.jsx';
import QuatreBoutonsAccueil from './QuatreBoutonsAccueil.jsx';

function VideoImageAccueil ({
    changerEtapeCollecteParticipation,
    participation,
    interaction,
    isImageBlur = true,
    textBTNParticiper = 'Participer',
    changerAfficherEtapeCollecteParticipationTexte,
    changerAfficherEtapeCollecteParticipationVoix,
    changerAfficherEtapeCollecteParticipationImage = null,
    retourAccueil,
    showImageParticipation = false,
    dispositionBoutons = 'horizontal',
    showDescription = false
}) {
    let [file, setFile] = useState();
    const fileRef = useRef();
    const [recordingState, setRecordingState] = useState('not-started');
    const readerRef = useRef({});
    const [recommencer, setRecommencer] = useState(false);
    const [clickedButton, setClickedButton] = useState('');

    const recommencerEnregistrement = async () => {
        setRecommencer(false);
        setRecordingState('not-started');
    }

    const [asAlreadyVoted, setAsAlreadyVoted] = useState('');
    const [showAlreadyVoted, setShowAlreadyVoted] = useState(false);

    const verifyAsAlreadVoted = (callback) => {
        if (interaction.limit_1_vote && interaction.asAlreadyVoted) {
            setAsAlreadyVoted('as-already-voted');
            setShowAlreadyVoted(true);
            setTimeout(() => {
                setAsAlreadyVoted('');
                setShowAlreadyVoted(false);
            }, 3000);
            return;
        }
        console.log(callback);
        callback();
    }
    const demanderEnregistrement = async () => {
        setClickedButton('btn-video');
        fileRef.current.click();
    }
    const clickChangerAfficherEtapeCollecteParticipationTexte = async () => {
        setClickedButton('btn-texte');
        changerAfficherEtapeCollecteParticipationTexte();

    }
    const clickChangerAfficherEtapeCollecteParticipationVoix = async () => {
        setClickedButton('btn-voix');
        changerAfficherEtapeCollecteParticipationVoix();

    }
    const readFile = async (e) => {
    }
    const endReadFile = async (e) => {
        setRecordingState('finished');
        participation.video = {}
        participation.video.url = URL.createObjectURL(file);
        participation.video.blob = e.target.result;
        // XXX Déclenche un rerender du composant
        //setContinueEnabled(true);
    }
    const uploadFromFile = async (e) => {
        setRecordingState('waiting');
        console.log('uploadFromFile');
        file = e.target.files[0];
        fileRef.current = file;
        readerRef.current = new FileReader();
        readerRef.current.onload = readFile;
        readerRef.current.onloadend = endReadFile;
        if (!file) {
            return;
        }
        if (file.type.includes('image')) {
            return { src: URL.createObjectURL(file), file: file };
        }
        setFile(file);
        readerRef.current.readAsArrayBuffer(file);
        setRecommencer(true);
    };

    // Pour l'upload de l'image

    let [fileImage, setFileImage] = useState();
    const fileImageRef = useRef();

    const clickChangerAfficherEtapeCollecteParticipationImage = async () => {
        setClickedButton('btn-image');
        fileImageRef.current.click();
    }

    const uploadFromFileImage = async (e) => {
        setRecordingState('waiting');
        participation.image = {}
        console.log('uploadFromFileImage');
        fileImage = e.target.files[0];
        fileImageRef.current = fileImage;
        if (!fileImage) {
            return;
        }
        participation.image.extension = fileImage.type.split('/')[1];
        participation.image.blob = URL.createObjectURL(fileImage);
        participation.image.file = fileImage;
        setFileImage(fileImage);
        setRecordingState('finished');
        console.log("finished");
    };
    return (
        <>
            {recordingState === 'not-started' && !showImageParticipation &&
                <TroisBoutonsAccueil
                    showAlreadyVoted={showAlreadyVoted}
                    asAlreadyVoted={asAlreadyVoted}
                    interaction={interaction}
                    isImageBlur={isImageBlur}
                    verifyAsAlreadVoted={verifyAsAlreadVoted}
                    demanderEnregistrement={demanderEnregistrement}
                    textBTNParticiper={textBTNParticiper}
                    changerAfficherEtapeCollecteParticipationVoix={clickChangerAfficherEtapeCollecteParticipationVoix}
                    changerAfficherEtapeCollecteParticipationTexte={clickChangerAfficherEtapeCollecteParticipationTexte}
                    dispositionBoutons={dispositionBoutons}
                    showDescription={showDescription}
                />
            }
            {recordingState === 'not-started' && showImageParticipation &&
                <QuatreBoutonsAccueil
                    showAlreadyVoted={showAlreadyVoted}
                    asAlreadyVoted={asAlreadyVoted}
                    interaction={interaction}
                    isImageBlur={isImageBlur}
                    verifyAsAlreadVoted={verifyAsAlreadVoted}
                    demanderEnregistrement={demanderEnregistrement}
                    textBTNParticiper={textBTNParticiper}
                    changerAfficherEtapeCollecteParticipationVoix={clickChangerAfficherEtapeCollecteParticipationVoix}
                    changerAfficherEtapeCollecteParticipationTexte={clickChangerAfficherEtapeCollecteParticipationTexte}
                    changerAfficherEtapeCollecteParticipationImage={clickChangerAfficherEtapeCollecteParticipationImage}
                />
            }
            <div className={recordingState === 'not-started' ? 'custom-upload-video' : 'custom-upload-video ' + clickedButton + ' fond-gris-widget'}>
                <Row className="custom-top-video">
                    <Col>
                        {!recommencer &&
                            <Form.Group>
                                <Form.Control type="file" accept={'video/*'} size="sm" onChange={uploadFromFile} ref={fileRef} id="selecteur" style={{ visibility: "hidden" }} />
                            </Form.Group>
                        }
                    </Col>
                </Row>
                {clickedButton === "btn-video" &&
                    <>
                        {
                            // Permet de forcer la mise à jour de l'aperçu
                        }
                        {recordingState === 'finished' &&
                            <>
                                <Row className="text-center text-16 titre-player">
                                    <Col>
                                        Aperçu de votre vidéo
                                    </Col>
                                </Row>
                                <Row className="text-center video-preview">
                                    <Col>
                                        <video width="300" muted autoplay="true" controls>
                                            <source src={URL.createObjectURL(file)} />
                                        </video>
                                    </Col>
                                </Row>
                            </>
                        }
                        {recommencer &&
                            <Row className="text-center">
                                <Col>
                                    <Button onClick={recommencerEnregistrement} className="btn-refaire-enregistrement-vocale">Recommencer l'enregistrement</Button>
                                </Col>
                            </Row>
                        }
                        {recordingState === 'finished' &&
                            <Row className="custom-commandes">
                                <Col>
                                    <Button onClick={changerEtapeCollecteParticipation} disabled={recordingState !== 'finished'}>Continuer</Button>
                                </Col>
                            </Row>
                        }
                    </>
                }

            </div>
            <div className={recordingState === 'not-started' ? 'custom-upload-image' : "custom-upload-image " + clickedButton + " fond-gris-widget"}>
                <Row>
                    <Col>
                        <Form.Group controlId="uploadImageFile" className="bouton-charger-image" style={{ visibility: "hidden" }}>
                            <Form.Control type="file" accept={'image/*'} size="sm" onChange={uploadFromFileImage} ref={fileImageRef} />
                        </Form.Group>
                    </Col>
                </Row>
                {clickedButton === "btn-image" &&
                    <>
                        {
                            // Permet de forcer la mise à jour de l'aperçu
                        }
                        {recordingState === 'finished' &&
                            <>
                                <Row className="text-center text-16">
                                    <Col>
                                        Aperçu
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        &nbsp;
                                    </Col>
                                </Row>
                                <Row className="text-center apercu-image">
                                    <Col>
                                        <img width="300" src={URL.createObjectURL(fileImage)} alt="aperçu" />
                                    </Col>
                                </Row>
                            </>
                        }
                        <Row>
                            <Col>
                                &nbsp;
                            </Col>
                        </Row>
                        <Row className="custom-commandes">
                            <Col>
                                <Button onClick={changerEtapeCollecteParticipation} disabled={recordingState !== 'finished'}>Continuer</Button>
                            </Col>
                        </Row>
                    </>
                }
            </div>
            {recordingState === 'finished' &&
                <Row className="text-center">
                    <Col>
                        <Button onClick={retourAccueil} className="custom-btn-retour">Retour</Button>
                    </Col>
                </Row>
            }

        </>
    )
};
export default memo(VideoImageAccueil);